module.exports = __webpack_public_path__ + "img/how_shop_6_en.24c5d3b7.png";